import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import CurrentPageContext from '../../../contexts/CurrentPageContext';
import AmenityIcon from '../../stateless/AmenityIcon';
import Translation from '../../stateless/Translation';
import { AMENITIES } from '../../../../modules/amenities';
import styles from './styles.scss';

const propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
};

const defaultProps = {
  description: undefined,
};

class Amenity extends React.Component {
  static contextType = CurrentPageContext;

  constructor(props) {
    super(props);

    this.name = React.createRef();
    this.description = React.createRef();
  }

  showDescription = (event) => {
    event.stopPropagation();
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onOpen();
    document.addEventListener('click', this.hideDescription);
  }

  hideDescription = (event) => {
    event.stopPropagation();
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onClose();
    document.removeEventListener('click', this.hideDescription);
  }

  renderAmenityName = ({ token, amenityNameStyle, amenityName }) => (
    <h5 className={styles.amenityName} ref={this.name} style={amenityNameStyle}>
      <Translation
        id={`widgets.facilityAmenities.${token}`}
        defaultMessage={amenityName}
      />
    </h5>
  )

  render() {
    const { isOpen, name, description } = this.props;

    const amenityNameStyle = {};
    const { primaryFontFamily, primaryColor } = this.context;

    if (primaryFontFamily) {
      amenityNameStyle.fontFamily = `${primaryFontFamily} !important`;
    }

    // eslint-disable-next-line jest/no-disabled-tests
    const { token, id, name: amenityName } = AMENITIES.find(({ test }) => test(name));

    const descriptionDisplay = (
      <React.Fragment>
        <button
          type="button"
          style={primaryFontFamily && { color: '#4a4a4a' }}
          onClick={this.hideDescription}
          className={styles.description}
          ref={this.description}
        >
          {description}
        </button>
        {this.renderAmenityName({ token, amenityNameStyle, amenityName })}
      </React.Fragment>
    );

    const amenityDisplay = (
      <React.Fragment>
        <button
          type="button"
          className={cx(styles.amenityIcon, { [styles.amenityIconHoverable]: description })}
          onClick={this.showDescription}
          disabled={!description}
          style={{ color: `${primaryColor} !important`, height: '60px', width: '60px' }}
        >
          <AmenityIcon id={id} label={name} />
        </button>
        {this.renderAmenityName({ token, amenityNameStyle, amenityName })}
      </React.Fragment>
    );
    return (
      <div
        className={styles.amenityContainer}
        style={{
          margin: '20px 0',
          display: 'inline-block',
          textAlign: 'center',
          verticalAlign: 'top',
          width: '125px',
          height: '120px',
        }}
      >
        {isOpen ? descriptionDisplay : amenityDisplay}

      </div>
    );
  }
}

Amenity.propTypes = propTypes;
Amenity.defaultProps = defaultProps;

export default Amenity;
